<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="$t('logs.title')"></page-header-title>

      <v-spacer></v-spacer>

      <v-layout row wrap>
        <v-flex xs12>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs3>
                <v-autocomplete
                  v-model="search_params.user_id"
                  @change="filter"
                  :items="users"
                  item-text="name"
                  item-value="id"
                  :label="$t('logs.user_id')"
                  autocomplete="new-password"
                  clearable
                  hide-details
                ></v-autocomplete>
              </v-flex>
              <v-flex xs3>
                <v-autocomplete
                  v-model="search_params.action_model"
                  @change="filter"
                  :items="this.$dd_action_models()"
                  item-text="text"
                  item-value="key"
                  :label="$t('logs.action_model')"
                  autocomplete="new-password"
                  clearable
                  hide-details
                ></v-autocomplete>
              </v-flex>
              <v-flex xs3>
                <v-dialog ref="dialog" v-model="from_date_menu" persistent width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="computedFromDate"
                      :label="$t('reports.from_date')"
                      append-icon="event"
                      @click:append="from_date_menu = true"
                      :hint="'Format: ' + DATE_FORMAT"
                      hide-details
                      autocomplete="new-password"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    @change="filter"
                    color="primary"
                    v-model="search_params.from_date"
                    first-day-of-week="1"
                    :locale="this.$locale_bcp47()"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="from_date_menu = false" class="darken-2">{{ $t("global.ok") }}</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex xs3>
                <v-dialog ref="dialog" v-model="to_date_menu" persistent width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="computedToDate"
                      :label="$t('reports.to_date')"
                      append-icon="event"
                      @click:append="to_date_menu = true"
                      :hint="'Format: ' + DATE_FORMAT"
                      hide-details
                      autocomplete="new-password"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    @change="filter"
                    color="primary"
                    v-model="search_params.to_date"
                    first-day-of-week="1"
                    :locale="this.$locale_bcp47()"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="to_date_menu = false" class="darken-2">{{ $t("global.ok") }}</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-app-bar>

    <v-card>
      <v-card-text>
        <v-flex md12>
          <v-data-table
            :headers="headers"
            :items="logs"
            :items-per-page="logs.length"
            :options.sync="pagination"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
              'items-per-page-all-text': $t('global.items_per_page_all_text'),
              'items-per-page-text': $t('global.items_per_page_text'),
              'page-text': $t('global.page_text')
            }"
            :server-items-length="total"
            :loading="show_loading"
            :loading-text="$t('global.loading_text')"
            :no-data-text="$t('global.no_data_text')"
            :no-results-text="$t('global.no_results_text')"
            :must-sort="true"
          >
            <template v-slot:item.action="{ item }">
              {{ item.action_custom }}
            </template>

            <template v-slot:item.user_id="{ item }">
              {{ item.user.person.first_name + " " + item.user.person.last_name }}
            </template>

            <template v-slot:item.action_id="{ item }">
              <router-link :to="`/app${item.action_link}`" v-if="item.action_name && item.action_link">
                {{ item.action_name }}
              </router-link>
              <div v-else>
                {{ item.action_name || item.action_id }}
              </div>
            </template>

            <template v-slot:item.created_at="{ item }">
              {{ moment(item.created_at).format(MYSQL_DATETIME_FORMAT) }}
            </template>

            <template v-slot:item.actions="{ item }">
              <action-button type="delete" @click="del(item.id)" v-if="$can('log-delete')" :icon_only="true" small />
            </template>
          </v-data-table>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "LogList",

  data() {
    return {
      url: "",
      logs: [],
      users: [],
      total: 0,
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
        page: this.$getLocalStorage("__page_Log_List", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["created_at"],
        sortDesc: [true]
      },
      search_params: {},
      from_date_menu: false,
      to_date_menu: false
    }
  },

  computed: {
    headers: {
      get() {
        return [
          { text: this.$t("logs.id"), value: "id" },
          { text: this.$t("logs.user_id"), value: "user_id" },
          { text: this.$t("logs.action"), value: "action" },
          { text: this.$t("logs.action_model"), value: "action_model" },
          { text: this.$t("logs.record"), value: "action_id" },
          { text: this.$t("logs.ip_address"), value: "ip_address" },
          { text: this.$t("logs.created_at"), value: "created_at" },
          { text: this.$t("global.actions"), value: "actions", width: "10%" }
        ]
      }
    },
    computedFromDate: {
      get() {
        return this.$dateFormatGetter(this.search_params.from_date)
      },
      set(val) {
        this.$set(this.search_params, "from_date", this.$dateFormatSetter(val))
      }
    },
    computedToDate: {
      get() {
        return this.$dateFormatGetter(this.search_params.to_date)
      },
      set(val) {
        this.$set(this.search_params, "to_date", this.$dateFormatSetter(val))
      }
    }
  },

  watch: {
    refresh: {
      handler() {
        if (this.refresh) {
          this.list()
        }
      }
    },
    pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (
            _.has(newVal, "sortBy") &&
            _.has(newVal, "sortDesc") &&
            _.has(oldVal, "sortBy") &&
            _.has(oldVal, "sortDesc") &&
            (!_.isEqual(newVal.sortBy, oldVal.sortBy) || !_.isEqual(newVal.sortDesc, oldVal.sortDesc))
          ) {
            let obj = {
              sortBy: this.pagination.sortBy,
              sortDesc: this.pagination.sortDesc
            }
            localStorage.setItem("__sort_Log_List", JSON.stringify(obj))
          }

          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__page_Log_List", newVal.page)
          }

          this.refresh = true
        }
      }
    }
  },

  mounted() {
    this.url = this.API_URL + "logs"
  },

  created() {
    let vm = this
    this.$set(
      this.search_params,
      "from_date",
      this.moment()
        .clone()
        .startOf("month")
        .format(this.MYSQL_DATE_FORMAT)
    )
    this.$set(
      this.search_params,
      "to_date",
      this.moment()
        .clone()
        .endOf("month")
        .format(this.MYSQL_DATE_FORMAT)
    )

    // Get Users
    axios.get(this.API_URL + "users?show_all=true").then((res) => {
      let users = res.data.data

      _.forEach(users, function(user) {
        vm.users.push({
          id: user.id,
          name: user.person.first_name + " " + user.person.last_name
        })
      })
    })
  },

  methods: {
    list(url) {
      this.show_loading = true

      let localFilter = localStorage.getItem("__filter_Log_List")
      if (localFilter !== null) {
        localFilter = JSON.parse(localFilter)
        this.search_params = localFilter
      }

      let localSort = localStorage.getItem("__sort_Log_List")
      if (localSort !== null) {
        localSort = JSON.parse(localSort)
        this.pagination.sortBy = localSort.sortBy
        this.pagination.sortDesc = localSort.sortDesc
      }

      let params = JSON.parse(JSON.stringify(this.search_params))
      params.from_date = params.from_date ? "gte-" + params.from_date : ""
      params.to_date = params.to_date ? "lte-" + params.to_date : ""

      let { sortBy, descending, page, itemsPerPage } = this.pagination
      let query = this.$queryString(this.pagination, params)

      axios
        .get(this.url + "?" + query)
        .then((res) => {
          this.logs = res.data.data
          this.total = res.data.meta.total
          this.refresh = false
          this.show_loading = false

          this.pagination.page = res.data.meta.current_page
          this.pagination.itemsPerPage = Number(res.data.meta.per_page)
        })
        .catch((err) => console.log(err))
    },

    filter(target) {
      this.pagination.page = 1
      this.refresh = true
      localStorage.setItem("__filter_Log_List", JSON.stringify(this.search_params))
    },

    reset() {
      this.$refs.form.reset()
      this.pagination.page = 1
      this.refresh = true
    },

    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "log/" + id)
            .then(() => {
              this.refresh = true
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },

    checkKeyPress(e) {
      if (e.key == "Enter") {
        this.filter()
      }
    }
  }
}
</script>

<style scoped></style>
